export const InformationWeCollect = [
    {
        h1: "Personal Information",
        p: `We may collect personally identifiable information, such as your name,
      email address, postal address, and phone number when you voluntarily
      provide it to us.`
    },
    {
        h1: "Non-Personal Information",
        p: `We may also collect non-personal information, such as browser type,
      device information, and usage data when you interact with our website.`
    }
];
export const HowWeUseYourInformation = [
    {
        h1: "Providing Services",
        p: `We use your personal information to provide the services you request,
      process transactions, and fulfill your requests.`
    },
    {
        h1: "Communication",
        p: `We may use your contact information to communicate with you about our
      services, updates, and promotional offers. You can opt-out of these
      communications at any time.`
    },
    {
        h1: "Analytics",
        p: `We use non-personal information for analytics purposes to improve our
      website, enhance user experience, and optimize our services.`
    }
];
export const CookiesAndSimilarTechnologies = [
    {
        h1: "Cookies",
        p: `We use cookies to enhance your experience on our website. You can manage
      your cookie preferences through your browser settings.`
    }
];
export const ThirdPartyLinks = [
    {
        h1: "External Websites",
        p: `Our website may contain links to external websites. We are not
      responsible for the privacy practices or content of these third-party
      sites.`
    }
];
export const Security = [
    {
        h1: "Data Security",
        p: `We employ industry-standard security measures to protect your personal
      information from unauthorized access, disclosure, alteration, and
      destruction.`
    }
];
export const YourChoices = [
    {
        h1: "Opt-Out",
        p: `You can opt-out of receiving promotional emails by following the
      instructions provided in the emails or contacting us directly.`
    }
];
export const ChangesToThisPrivacyPolicy = [
    {
        h1: "Updates",
        p: `We reserve the right to update this Privacy Policy periodically. Any
      changes will be effective upon posting the revised policy on our
      website.`
    }
];
export const ContactUs = [
    {
        h1: "Questions",
        p: `If you have any questions or concerns, please contact us at MDpharmacy@gmail.com.`
    }
];